import {connect} from 'react-redux';
import {PlantTank as Component} from './PlantTank';
import {
  createPlantTank,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("plantTanks") &&
     state.notebook.protocolSection.scene.apparatus.plantTanks.some(
       box => box.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.plantTanks[ownProps.id-1].type,
      numberOfPlants: state.notebook.protocolSection.scene.apparatus.plantTanks[ownProps.id-1].numberOfPlants
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createPlantTank: (data)=>{
      dispatch(createPlantTank(data))
    },
  };
}

export const PlantTank = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
